import type { ReactNode } from 'react';
import { Header } from './Header';
import { cn } from '@/lib/cn';

interface ScreenLayoutProps {
  title?: string;
  onBack?: () => void;
  onClose?: () => void;
  cta?: ReactNode;
  children: ReactNode;
  className?: string;
  /** Скрыть верхний Header (используется на Welcome — там свой большой brand-mark). */
  hideHeader?: boolean;
}

/**
 * Единая раскладка экрана: Header сверху, контент в скроллящейся области,
 * опциональный sticky CTA-блок внизу с safe-area.
 */
export function ScreenLayout({
  title,
  onBack,
  onClose,
  cta,
  children,
  className,
  hideHeader,
}: ScreenLayoutProps) {
  return (
    <div className="flex min-h-full flex-col bg-background text-text-primary">
      {!hideHeader && <Header title={title} onBack={onBack} onClose={onClose} />}
      <main className={cn('flex-1 px-5 pt-6 pb-6', className)}>{children}</main>
      {cta && (
        <div className="sticky bottom-0 z-10 border-t border-border bg-background px-5 pt-3 pb-3 safe-bottom">
          {cta}
        </div>
      )}
    </div>
  );
}
